/*
 * projects_pdf_js.js — esbuild IIFE entry
 * Provides numberPages() for WickedPDF layouts (projects_pdf.html.haml).
 * Originally in app/assets/javascripts/projects_pdf_js.js (Sprockets).
 */

window.numberPages = function () {
  const vars = {};
  document.location.search.substring(1).split('&').forEach(pair => {
    const [key, val] = pair.split('=', 2);
    vars[key] = decodeURIComponent(val || '');
  });
  ['topage', 'page'].forEach(cls => {
    document.querySelectorAll(`.${cls}`).forEach(el => {
      el.textContent = vars[cls] || '';
    });
  });
};
